module.exports = __webpack_public_path__ + "img/stance3.8840d7b6.png";